import { BdaDataset } from "../models/BdaDataset";
import { BdaModel } from "../models/BdaModel";
import { BdaService } from "../models/BdaService";
import { KrakendCollection } from "../models/generics";
import client from "./axios";

export const Designer = {
  getServices: (params?: URLSearchParams) => client.get<BdaService[]>(`${window.__env.KRAKEND_URL}/v0/services`, { params }),
  getService: (id: number, params?: URLSearchParams) => client.get<BdaService>(`${window.__env.KRAKEND_URL}/v0/services/${id}`, { params }),
  getDatasets: (params?: URLSearchParams) => client.get<KrakendCollection<BdaDataset>>(`${window.__env.KRAKEND_URL}/v1/datasets`, { params }),
  getDataset: (id: number, params?: URLSearchParams) => client.get<BdaDataset>(`${window.__env.KRAKEND_URL}/v1/datasets/${id}`, { params }),
  getModels: (params?: URLSearchParams) => client.get<KrakendCollection<BdaModel>>(`${window.__env.KRAKEND_URL}/v1/models`, { params }),
  getModel: (id: number, params?: URLSearchParams) => client.get<BdaModel>(`${window.__env.KRAKEND_URL}/v1/models/${id}`, { params }),
}